module.exports = __webpack_public_path__ + "static/media/sidebar-bg.3b3892d1.jpg";